<div class="container-fuid bg-white default-boxrounded">
    <div class="p-0">
        <iframe id="bridgeIntegrationUrl" [src]="bridgeIntegrationUrl" title="Afas settings" class="w-100 default-boxrounded" [height]="iframeHeight"></iframe>
    </div>
</div>